import type { Order } from '@skop-app/lib-domain/types'

import type { OrderModalValues } from '@/types'

export const sumOrdersByCurrency = (orders: Order[]) => {
  const amounts = new Map<string, number>()
  for (const order of orders) {
    if (order.rawTotal == null) continue
    const currency = String(
      (order as Order & { currency?: string }).currency ?? 'EUR',
    ).toUpperCase()
    amounts.set(
      currency,
      (amounts.get(currency) ?? 0) + (Number(order.rawTotal) || 0),
    )
  }
  return Array.from(amounts, ([currency, value]) => ({
    name: currency,
    currency,
    value,
  }))
}

export const hasOrderCurrencyMismatch = (
  items: OrderModalValues['items'],
  currency: unknown,
): boolean =>
  (items ?? []).some((item) =>
    Boolean(
      item.currency &&
      item.currency.toUpperCase() !== String(currency ?? 'eur').toUpperCase(),
    ),
  )

/** A transfer aggregate is meaningful only when its effective line units agree. */
export const getOrderAggregateCurrency = (
  order: OrderModalValues,
  isOrder = true,
): string | undefined => {
  const fallback = String(order.currency?.value || 'eur')
  if (isOrder) return fallback
  let aggregateCurrency: string | undefined
  for (const item of order.items ?? []) {
    const currency = item.currency || fallback
    if (
      aggregateCurrency &&
      currency.toUpperCase() !== aggregateCurrency.toUpperCase()
    ) {
      return undefined
    }
    aggregateCurrency ??= currency
  }
  return aggregateCurrency ?? fallback
}

export const hasValidOrderTaxRate = (
  value: unknown,
  currency: unknown,
): boolean => {
  const rate =
    value ??
    (String(currency ?? 'eur').toUpperCase() === 'EUR' ? 20 : undefined)
  return (
    rate != null &&
    Number.isFinite(Number(rate)) &&
    Number(rate) >= 0 &&
    Number(rate) <= 100
  )
}
